import { z } from "zod";
import type { StateCreator } from "zustand";
import type { Store } from "../globalStore";

export enum SlotStatusEnum {
  PENDING = "PENDING",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
  CONFIRMED = "CONFIRMED",
}

export const TemporarySlot = z.object({
  startTime: z.string().datetime(),
  endTime: z.string().datetime(),
  providerId: z.number().int(),
  practiceId: z.number().int(),
  ehrVisitId: z.string().optional(),
  timezone: z.string(),
  isVirtualVisit: z.boolean(),
  ehrAppointmentTypeId: z.string(),
});

export type TemporarySlot = z.infer<typeof TemporarySlot>;

export enum SelectedAppointmentTimeEnum {
  ASAP = "ASAP",
}

export type BookingSlice = {
  temporarySlot: TemporarySlot | null;
  setTemporarySlot: (slot: TemporarySlot) => void;
  clearTemporarySlot: () => void;
  selectedAppointmentTime: Date | SelectedAppointmentTimeEnum | null;
  setSelectedAppointmentTime: (
    appointmentTime: Date | SelectedAppointmentTimeEnum | null,
  ) => void;
  clearSelectedAppointmentTime: () => void;
  practiceId: number | null;
  setPracticeId: (practiceId: number | null) => void;
  clearPracticeId: () => void;
  selectedZipCode: string | null;
  setSelectedZipCode: (zipCode: string | null) => void;
  clearSelectedZipCode: () => void;
};

export const bookingInitialState = {
  temporarySlot: null,
  selectedAppointmentTime: null as Date | SelectedAppointmentTimeEnum | null,
  practiceId: null as number | null,
  selectedZipCode: null as string | null,
};

export const createBookingSlice: StateCreator<
  Store,
  [["zustand/devtools", never], ["zustand/persist", unknown]],
  [],
  BookingSlice
> = (set) => ({
  ...bookingInitialState,
  setTemporarySlot: (slot) => {
    set((state) => ({ ...state, temporarySlot: slot }));
  },
  clearTemporarySlot: () => {
    set((state) => ({ ...state, temporarySlot: null }));
  },
  setSelectedAppointmentTime: (appointmentTime) => {
    set((state) => ({ ...state, selectedAppointmentTime: appointmentTime }));
  },
  clearSelectedAppointmentTime: () => {
    set((state) => ({ ...state, selectedAppointmentTime: null }));
  },
  setPracticeId: (practiceId) => {
    set((state) => ({ ...state, practiceId }));
  },
  clearPracticeId: () => {
    set((state) => ({ ...state, practiceId: null }));
  },
  setSelectedZipCode: (zipCode) => {
    set((state) => ({ ...state, selectedZipCode: zipCode }));
  },
  clearSelectedZipCode: () => {
    set((state) => ({ ...state, selectedZipCode: null }));
  },
});
